import {
  BaseComboboxInputProps,
  ComboboxInput,
} from "@/lib/Components/Form/Inputs/ComboboxInput";
import {
  ProDriverAgreementTemplateRecord,
  proDriverAgreementTemplateListQuery,
  proDriverAgreementTemplateRecordQuery,
} from "@/app/ProDrivers/Agreements/GraphQL/agreementTemplateQueries";
import { ResultOf, VariablesOf } from "@graphql-typed-document-node/core";
import { useDialog } from "@/lib/Components/Dialog/Hooks/useDialog";
import { AgreementTemplateDialog } from "@/app/ProDrivers/Agreements/Components/Dialogs/AgreementTemplateDialog";
import { DocumentTextIcon } from "@heroicons/react/20/solid";

export function AgreementTemplateInput(
  props: BaseComboboxInputProps<
    ResultOf<typeof proDriverAgreementTemplateListQuery>,
    VariablesOf<typeof proDriverAgreementTemplateListQuery>,
    ProDriverAgreementTemplateRecord
  >,
) {
  const { openAsPromise } = useDialog(AgreementTemplateDialog);

  return (
    <ComboboxInput
      document={proDriverAgreementTemplateListQuery}
      accessor={(data) => data.proDriverAgreementTemplates}
      getQueryVariables={() => ({})}
      recordDocument={proDriverAgreementTemplateRecordQuery}
      recordAccessor={(data) => data.proDriverAgreementTemplate!}
      LeadingIcon={DocumentTextIcon}
      getKey={(template) => template.id}
      getInputNode={(template) => template.name}
      getListItemNode={(template) => (
        <div className="flex flex-col">
          <span>{template.name}</span>
          <span className="text-xs text-gray-500">{template.title}</span>
        </div>
      )}
      getViewNode={(template) => template?.name ?? null}
      fixture={(search) => ({
        label: search ? `Create "${search}" template` : "Create a template",
        onClick: () => openAsPromise({ initialValues: { name: search } }),
      })}
      {...props}
    />
  );
}
